import { render, staticRenderFns } from "./AddBuyerYearInvoice.vue?vue&type=template&id=3360eeec&scoped=true&"
import script from "./AddBuyerYearInvoice.vue?vue&type=script&lang=js&"
export * from "./AddBuyerYearInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3360eeec",
  null
  
)

export default component.exports